/* el-consent — behaviour for the consent modal. Bound ONCE, four listeners, none in a loop,
 * no jQuery, and one namespaced object as the only state.
 *
 * Platform contract — Shopify's Customer Privacy API (native, no app):
 *   loadFeatures('consent-tracking-api') -> shouldShowBanner() -> setTrackingConsent().
 * Shopify persists the visitor's choice, so this file writes no cookie of its own.
 *
 * The consent rule: ONLY the two buttons make a choice. Esc, a backdrop click and every other
 * close path fall through the dialog's own `close` event and record ESSENTIAL ONLY —
 * a non-choice never grants consent.
 *
 * ?el-consent-preview=1 forces the dialog open, records nothing and needs no API at all, so a
 * tester outside the EU-27 (where the policies are set to required) can see the real thing.
 */
(function () {
  var EL = {
    dialog: null,
    decided: false,
    preview: /[?&]el-consent-preview=1(?:&|$)/.test(window.location.search),
  };

  function dialog() {
    if (!EL.dialog) EL.dialog = document.querySelector('[data-el-consent]');
    return EL.dialog;
  }

  function privacy() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  /* Records, and nothing else: closing is handled in exactly one place (the close listener),
     so the two paths can never disagree about what was recorded. */
  function record(granted) {
    if (EL.preview) return;
    var api = privacy();
    if (!api || typeof api.setTrackingConsent !== 'function') return;
    try {
      api.setTrackingConsent(
        { analytics: granted, marketing: granted, preferences: granted, sale_of_data: false },
        function () {}
      );
    } catch (error) {
      /* a failed write must never trap a visitor behind the dialog */
    }
  }

  function open() {
    var node = dialog();
    if (!node || node.open || typeof node.showModal !== 'function') return;
    node.showModal();
    /* Viktor: "the background gets overshadowed a bit until it's closed" — a native <dialog>
       dims but does not lock the page, so the html-level lock the cart drawer already uses
       holds the page still while the choice is open (2026-09-19). */
    document.documentElement.classList.add('el-scroll-locked');
  }

  function choose(granted) {
    var node = dialog();
    EL.decided = true;
    record(granted);
    if (node && node.open) node.close();
  }

  function bind() {
    var node = dialog();
    if (!node) return false;

    var accept = node.querySelector('[data-el-consent-accept]');
    var essential = node.querySelector('[data-el-consent-essential]');

    if (accept) {
      accept.addEventListener('click', function () {
        choose(true);
      });
    }

    if (essential) {
      essential.addEventListener('click', function () {
        choose(false);
      });
    }

    /* The backdrop is the dialog's own pseudo-element, so a click on it retargets to the
       dialog. All padding sits on the inner card, so this can only be the backdrop. */
    node.addEventListener('click', function (event) {
      if (event.target === node && node.open) node.close();
    });

    /* Tab never parks on <body>: Chromium's top-layer walk stops there between the last and
       the first control. Same wrap the cart drawer runs (judge 2026-09-19). */
    node.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var f = node.querySelectorAll('a[href], button:not([disabled])');
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      var onCard = document.activeElement === node || document.activeElement === node.firstElementChild;
      if (event.shiftKey && (document.activeElement === first || onCard)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    /* Esc, the backdrop, a programmatic close: one event covers every path out that is not
       a button, and every one of them means essential only. */
    node.addEventListener('close', function () {
      document.documentElement.classList.remove('el-scroll-locked');
      if (!EL.decided) record(false);
      EL.decided = false;
    });

    return true;
  }

  function start() {
    if (!bind()) return;

    if (EL.preview) {
      open();
      return;
    }

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error) return;
      var api = privacy();
      if (!api || typeof api.shouldShowBanner !== 'function') return;
      if (api.shouldShowBanner()) open();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
